// Header Component

import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/auth-store';
import { trpc } from '../../lib/trpc';

export function Header() {
  const navigate = useNavigate();
  const { logout, refreshToken } = useAuthStore();

  const logoutMutation = trpc.auth.logout.useMutation({
    onSettled: () => {
      logout();
      navigate('/login');
    },
  });

  const handleLogout = () => {
    if (refreshToken) {
      logoutMutation.mutate({ refreshToken });
    } else {
      logout();
      navigate('/login');
    }
  };

  return (
    <header className="flex h-16 items-center justify-between border-b bg-white px-6">
      <div>
        {/* Breadcrumb or page title can go here */}
      </div>

      <div className="flex items-center gap-4">
        {/* Notifications */}
        <button
          type="button"
          className="rounded-full p-2 text-gray-500 hover:bg-gray-100 hover:text-gray-700"
        >
          <span className="sr-only">Notifications</span>
          <svg
            className="h-5 w-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
            />
          </svg>
        </button>

        <a
          href="mailto:support@calculom.com?subject=Calculom%20Support%20Request"
          className="btn-secondary text-sm"
        >
          Support
        </a>

        {/* Logout */}
        <button
          type="button"
          onClick={handleLogout}
          disabled={logoutMutation.isPending}
          className="btn-secondary text-sm"
        >
          {logoutMutation.isPending ? 'Logging out...' : 'Logout'}
        </button>
      </div>
    </header>
  );
}
